"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { buildAssetUrl } from './buildAssetUrl';
const createResource = promise => {
  let status = 'pending';
  let result;
  const suspender = promise.then(data => {
    status = 'success';
    result = data;
  }, error => {
    status = 'error';
    result = error;
  });
  return {
    read() {
      if (status === 'pending') {
        throw suspender;
      }
      if (status === 'error') {
        throw result;
      }
      return result;
    }
  };
};
const manifestCache = {};
export const useMFEManifestFetch = t0 => {
  const $ = _c(9);
  const {
    mfeAppName,
    tenantName,
    staticMFEUrl
  } = t0;
  const [resource, setResource] = useState(null);
  let t1;
  let t2;
  if ($[0] !== mfeAppName || $[1] !== staticMFEUrl || $[2] !== tenantName) {
    t1 = () => {
      const cacheKey = `${mfeAppName}-${tenantName}-${staticMFEUrl}`;
      if (manifestCache[cacheKey]) {
        setResource(createResource(Promise.resolve(manifestCache[cacheKey])));
      } else {
        const fetchManifest = fetch(buildAssetUrl({
          asset: "build-manifest.json",
          mfeAppName,
          staticMFEUrl
        })).then(_temp).then(manifest => {
          manifestCache[cacheKey] = manifest;
          return manifest;
        });
        setResource(createResource(fetchManifest));
      }
    };
    t2 = [mfeAppName, tenantName, staticMFEUrl];
    $[0] = mfeAppName;
    $[1] = staticMFEUrl;
    $[2] = tenantName;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== resource) {
    t3 = resource === null || resource === void 0 ? void 0 : resource.read();
    $[5] = resource;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      manifest: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(res) {
  return res.json();
}